import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useQuoteEditor } from "../context/QuoteEditorContext"
import { useEndpoints }   from "../context/EndpointsContext"

const TABS = [
  { key: "edit",     labelKey: "editor",  icon: "pen-to-square" },
  { key: "preview",  labelKey: "preview", icon: "eye" },
  { key: "margins",  labelKey: "margins", icon: "scale-balanced" },
  { key: "settings", labelKey: "summary", icon: "circle-info" },
  { key: "library",  labelKey: "library", icon: "folder-open" },
]

const TabBar = () => {
  const { state, dispatch } = useQuoteEditor()
  const { library_url }     = useEndpoints()
  const active = state.activeTab || "edit"
  // The Marges tab exposes the dry cost and the margin, so it follows the
  // margin right, not the right to open the quote.
  const tabs = TABS
    .filter(tab => tab.key !== "margins" || state.showMargin)
    .filter(tab => tab.key !== "edit"    || !state.readOnly)
    // An unsaved quote has nowhere to file a document yet.
    .filter(tab => tab.key !== "library" || library_url)

  return (
    <div className="flex items-center gap-1">
      {tabs.map(tab => {
        const isActive = active === tab.key
        return (
          <button
            key       = {tab.key}
            type      = "button"
            onClick   = {() => dispatch({ type: "SET_TAB", payload: tab.key })}
            className = {clsx(
              "inline-flex items-center gap-1.5 px-3 py-2 text-[13px] font-medium border-b-2 -mb-px focus:outline-none focus-visible:outline-none",
              isActive
                ? "border-brand-500 text-brand-600"
                : "border-transparent text-slate-500 hover:text-slate-900"
            )}
          >
            <FontAwesomeIcon icon={tab.icon} className="text-xs" />
            {I18n.t(`quotes.builder.tabs.${tab.labelKey}`)}
          </button>
        )
      })}
    </div>
  )
}

export default TabBar
